/**
 * Central API route registry for the Administration platform.
 * All paths are relative to REACT_APP_API_BASE_URL (see src/api/axiosClient.js).
 * Source: FE Handoff Rev-2 sections 11-17.
 */

const API = {
  auth: {
    login: '/api/v1/admin/auth/login',
  },

  // PlatformAdmin - administration user management
  users: {
    list: '/api/v1/admin/users',
    create: '/api/v1/admin/users',
    status: (id) => `/api/v1/admin/users/${id}/status`,
  },

  // Dashboards
  cioDashboard: '/api/v1/admin/cio/dashboard',
  cfoDashboard: '/api/v1/admin/cfo/dashboard',

  // Public reference + onboarding
  onboarding: {
    industries: '/api/v1/onboarding/industries',
    form: (token) => `/api/v1/onboarding/forms/${token}`,
  },

  // CIO - invitations
  invitations: {
    base: '/api/v1/admin/cio/onboarding-invitations',
  },

  // CIO - customers (clients)
  clients: {
    list: '/api/v1/admin/cio/clients',
    detail: (id) => `/api/v1/admin/cio/clients/${id}`,
    commercialTerms: (id) => `/api/v1/admin/cio/clients/${id}/commercial-terms`,
    deployment: (id) => `/api/v1/admin/cio/clients/${id}/deployment`,
    status: (id) => `/api/v1/admin/cio/clients/${id}/status`,
    rotateIntegrationKey: (id) => `/api/v1/admin/cio/clients/${id}/integration-key/rotate`,
  },

  // Controlled customer support-access audit (note: /admin/clients, NOT /admin/cio/clients)
  supportAccess: {
    base: (clientId) => `/api/v1/admin/clients/${clientId}/support-access`,
    complete: (clientId, auditId) =>
      `/api/v1/admin/clients/${clientId}/support-access/${auditId}/complete`,
  },

  // CIO - Tech Support & Issues (live backend, verified against Swagger)
  tickets: {
    base: '/api/v1/admin/cio/support-tickets',
    detail: (id) => `/api/v1/admin/cio/support-tickets/${id}`,
    status: (id) => `/api/v1/admin/cio/support-tickets/${id}/status`,
    assignment: (id) => `/api/v1/admin/cio/support-tickets/${id}/assignment`,
    assignees: '/api/v1/admin/cio/support-tickets/assignees',
  },

  // CFO - pricing plans
  pricingPlans: {
    base: '/api/v1/admin/cfo/pricing-plans',
    status: (id) => `/api/v1/admin/cfo/pricing-plans/${id}/status`,
  },

  // CFO - invoices
  invoices: {
    base: '/api/v1/admin/cfo/invoices',
    preview: (clientId) => `/api/v1/admin/cfo/invoices/preview/${clientId}`,
    detail: (invoiceId) => `/api/v1/admin/cfo/invoices/${invoiceId}`,
    document: (invoiceId) => `/api/v1/admin/cfo/invoices/${invoiceId}/document`,
    send: (invoiceId) => `/api/v1/admin/cfo/invoices/${invoiceId}/send`,
    confirmPayment: (invoiceId) => `/api/v1/admin/cfo/invoices/${invoiceId}/confirm-payment`,
  },
};

export default API;
